import styles from './Card.module.css';

interface CardProps {
	active?: boolean;
	children: React.ReactNode;
	className?: string;
}

export function Card({ active = false, children, className }: CardProps) {
	return (
		<div
			className={[styles.card, active ? styles.cardActive : '', className]
				.filter(Boolean)
				.join(' ')}
		>
			{children}
		</div>
	);
}
